import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllSalesReviews = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_ALL_SALES_REVIEWS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/cs/sale-reviews`, {
            params: {
              'request-id': reqId,
              last_seen: null,
              size: 100,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_ALL_SALES_REVIEWS_DONE',
              payload: {
                salesReviews: response?.data?.saleReviews,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data?.saleReviews);
            }
          } else {
            dispatch({
              type: 'FETCHING_ALL_SALES_REVIEWS_FAILED',
              payload: `Failed to get sales reviews`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_ALL_SALES_REVIEWS_FAILED',
            payload: `Failed to get sales reviews`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_ALL_SALES_REVIEWS_FAILED',
        payload: `Failed to get sales reviews`,
      });
    }
  };
};

export default getAllSalesReviews;
